import Vue from 'vue';

const types = {
	SET_INVALID_MESSAGE: 'SET_INVALID_MESSAGE',
	SET_VALID_STATE: 'SET_VALID_STATE',
};

const state = {
	firstName: {},
	lastName: {},
	email: {},
	phone: {},
	retry_phone: {},
	textVerify: {},
	make: {},
	model: {},
	year: {},
};

const getters = {};

const actions = {
	init() {
		// eslint-disable-next-line guard-for-in
		for (const prop in state) {
			state[prop] = {
				error: '',
				isValid: false,
				suggested: '',
				value: '',
				touched: false,
				loading: false,
			};
		}
	},

	invalidMessage({ commit }, payload) {
		this._vm.$log.debug(payload);

		commit(types.SET_INVALID_MESSAGE, payload);

		if (payload.message) {
			commit(types.SET_VALID_STATE, {
				field: payload.field,
				isValid: false,
			});
		}
	},
};

const mutations = {
	RESET_FIELD(state, payload) {
		Vue.set(state[payload.field], 'isValid', false);
		Vue.set(state[payload.field], 'touched', payload.touched || true);
		Vue.set(state[payload.field], 'loading', false);
		Vue.set(state[payload.field], 'error', '');
		Vue.set(state[payload.field], 'suggested', '');
		Vue.set(state[payload.field], 'value', payload.value);
	},

	SET_INVALID_MESSAGE(state, payload) {
		Vue.set(state[payload.field], 'error', payload.message);
	},

	SET_PROPERTY(state, payload) {
		Vue.set(state[payload.field], payload.prop, payload.value);
	},

	SET_VALID_STATE(state, payload) {
		this._vm.$log.debug(payload);
		const field = state[payload.field];

		Vue.set(field, 'loading', false);
		Vue.set(field, 'touched', true);

		if (payload.isValid) {
			Vue.set(field, 'isValid', payload.isValid);
			Vue.set(field, 'error', '');
		} else if (payload.data) {
			const data = payload.data;

			// Suggested message could be given for both valid/invalid email
			if (data.suggested) {
				Vue.set(field, 'suggested', data.data.did_you_mean);
			}

			if (data.valid || data.success) {
				Vue.set(field, 'isValid', true);
			} else {
				Vue.set(field, 'error', payload.data.message);
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
